import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TagFollowToggle from './TagFollowToggle.jsx';

export default class TagFollowWrapper extends Component {
  static propTypes = {
    tagParams: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    })).isRequired,
    seeMoreUrl: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = { toggled: {} };
  }

  handleTagClick = (tagId) => {
    const toggled = this.state.toggled;
    toggled[tagId] = !toggled[tagId];
    // We filter for those tags which are currently toggled (i.e. true), and count them.
    const toggledCount = Object.values(toggled).filter((value) => value).length;
    if (toggledCount > 0) {
      $('#close-interest-prompt').html('Done');
    } else {
      $('#close-interest-prompt').html('Skip this');
    }
    this.setState({ toggled });
  }

  handleCloseClick = (e) => {
    e.preventDefault();
    const expires = new Date();
    expires.setMonth(expires.getMonth() + 1);
    document.cookie = `dismiss_interests=true; expires=${expires.toUTCString()}`;
    $('#tags-wrapper').hide();
  }

  renderTags() {
    return this.props.tagParams.map((tag) => (
      <TagFollowToggle
        url={tag.url}
        name={tag.name}
        id={tag.id}
        key={tag.id}
        onClick={this.handleTagClick}
      />
    ));
  }

  render() {
    return (
      <div className="Prompt--interestTags-tagList" id="tags-wrapper">
        {this.renderTags()}
        <em className="u-seeMore u-ml-2" >
          <a href={this.props.seeMoreUrl}>
            See more
          </a>
        </em>

        <div className="u-float-right u-seeMore u-mt-4">
          <a href="#" id="close-interest-prompt" onClick={this.handleCloseClick}>
            Skip this
          </a>
        </div>
      </div>
    );
  }
}
